<template>
  <v-card id="customer-form">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-form
      ref="CustomerForm"
      v-model="valid"
      lazy-validation
    >
      <v-card-title>Customer Form</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="CustomerForm.crm_id"
          label="ID CRM"
          required
          :disabled="crmIdDisabled"
          :rules="crm_id_rules"
          :counter="20"
        />

        <v-text-field
          v-model="CustomerForm.ragione_sociale"
          label="Ragione Sociale"
          required
          :rules="ragione_sociale_rules"
          :counter="255"
        />

        <v-text-field
          v-model="CustomerForm.c_description"
          label="Customer Description"
          :rules="c_description_rules"
          :counter="255"
        />

        <v-radio-group
          v-model="CustomerForm.account_type"
          label="Account Type"
          row
          mandatory
          color="color_green"
        >
          <v-radio
            label="B2B"
            :ripple="true"
            value="B2B"
            color="color_green"
          />
          <v-radio
            label="Ecommerce"
            :ripple="true"
            value="ECOMMERCE"
            color="color_green"
          />
        </v-radio-group>

        <v-autocomplete
          v-model="CustomerForm.timezone"
          label="Timezone"
          :items="timezones"
          :rules="timezone_rules"
          :required="isEcommerce"
        />

        <v-text-field
          v-model="CustomerForm.webhook_url"
          label="Webhook URL"
          hint="Opzionale"
          persistent-hint
          :rules="webhook_url_rules"
          :counter="2048"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          class="mr-4"
          @click.prevent="clear"
        >
          Clear
        </v-btn>
        <v-spacer />
        <v-btn
          dark
          color="color_green"
          class="mr-4"
          :disabled="checkForm()"
          @click="submit"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required, manageLenghtError, getRegExp } from '@/formRules.js';

const timezones = typeof Intl.supportedValuesOf === 'function'
  ? Intl.supportedValuesOf('timeZone')
  : [
    'Europe/Rome',
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    'Europe/Madrid',
    'UTC'
  ];

export default {
  data() {
    return {
      overlay: false,
      valid: true,
      timezones,
      CustomerForm: {
        crm_id: '',
        ragione_sociale: '',
        c_description: '',
        state: true,
        account_type: 'B2B',
        timezone: 'Europe/Rome',
        webhook_url: ''
      },
      crmIdDisabled: false,
      crm_id_rules: [
        ...required,
        ...manageLenghtError(20),
        ...getRegExp('space_not_allowed')
      ],
      ragione_sociale_rules: [...required, ...manageLenghtError(255)],
      c_description_rules: [...manageLenghtError(255)]
    };
  },
  computed: {
    ...mapState(['customer', 'disableTab']),
    isEcommerce() {
      return this.CustomerForm.account_type === 'ECOMMERCE';
    },
    timezone_rules() {
      return this.isEcommerce ? [...required] : [];
    },
    webhook_url_rules() {
      const lengthRule = v =>
        !v || v.length <= 2048 || 'Field must be less than 2048 characters';

      return [lengthRule, ...getRegExp('url')];
    }
  },
  created() {
    if (this.customer.isModifingCustomer) {
      this.CustomerForm = this.$store.state.customerCRMID;
      this.crmIdDisabled = true;
    }
  },

  methods: {
    ...mapActions([
      'storeNewCustomer',
      'storeUpdatedCustomer',
      'storeCustomerCRMID',
      'switchTabState',
      'storeToastMessage',
      'storeTechUsers',
      'storeCRMID',
      'storeCustomers'
    ]),
    checkForm() {
      return !(
        this.valid &&
        this.CustomerForm.crm_id !== '' &&
        this.CustomerForm.ragione_sociale !== ''
      );
    },
    async submit() {
      this.overlay = true;

      if (!this.checkForm() && this.valid) {
        if (this.customer.isModifingCustomer) {
          await this.storeUpdatedCustomer(this.CustomerForm);
        } else {
          try {
            await this.storeNewCustomer(this.CustomerForm);
            this.crmIdDisabled = true;
            this.$store.state.disableTab = false;
            this.customer.isModifingCustomer = true;
          } catch {
            this.CustomerForm.crm_id = '';
            this.clear();
          }
        }

        await this.storeCustomerCRMID(this.CustomerForm);
        await this.storeCRMID(this.CustomerForm.crm_id);
        await this.storeTechUsers(this.CustomerForm.crm_id);
        this.$emit('toParent', this.CustomerForm);
      } else {
        this.storeToastMessage({
          text: 'Please set required fields',
          type: 'warning'
        });
      }

      this.overlay = false;
    },
    clear() {
      this.CustomerForm.ragione_sociale = '';
      this.CustomerForm.c_description = '';
      this.CustomerForm.account_type = 'B2B';
      this.CustomerForm.timezone = 'Europe/Rome';
      this.CustomerForm.webhook_url = '';
    }
  }
};
</script>
